import { useParams } from 'react-router-dom';

import NavBar from '../../components/NavBar';
import { StyledContainer } from './AddVisit.style';
import AddVisitInputsInputs from './AddVisitInputs';

const AddVisit = (): JSX.Element | null => {
  const { propertyId } = useParams();
  return (
    <StyledContainer>
      <NavBar />
      {propertyId && <AddVisitInputsInputs property_id={propertyId ?? ''} />}
    </StyledContainer>
  );
};
export default AddVisit;
